import { type CSSProperties } from "react";
import { getSizeByPredefinedSize } from "@/utils/style/getSizeByPredefinedSize";
import type { BaseSiteBuilderModule } from "@/types/site-builder";

type Settings = BaseSiteBuilderModule["settings"]["container"];

export function getModuleContainerStyle(settings: Settings): CSSProperties {
  return {
    minHeight: getSizeByPredefinedSize(settings.minHeight),
    marginTop: getSizeByPredefinedSize(settings.marginTop),
    marginBottom: getSizeByPredefinedSize(settings.marginBottom),
    paddingTop: getSizeByPredefinedSize(settings.paddingTop),
    paddingBottom: getSizeByPredefinedSize(settings.paddingBottom),
  };
}
